/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('persons-chip', {
    template: `<label data-bind="visible: visible, html: text, click: remove"></label>`,
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new PersonsChipViewModel(params, componentInfo);
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
function PersonsChipViewModel(params, componentInfo) {
  var self = this;

  self.text = ko.pureComputed(function () {
    if (params.data.Adults() == 0) {
      return ('');
    } else if (params.data.Children() == 0) {
      return (params.data.Adults() + ' Erw.');
    } else {
      return (params.data.Adults() + ' Erw., ' + params.data.Children() + (params.data.Children() == '1' ? ' Kind' : ' Kinder'));
    }
  }, self);

  self.visible = ko.pureComputed(function () {
    return params.data.Adults() != 0 || params.data.Children() != 0;
  }, self);

  self.remove = function (data, event) {
    var $form = $(event.currentTarget).closest('form');
    params.data.Adults('');
    params.data.Children('');
    $form.trigger('update');
  };
}
